import { AccountUpdater as r } from "./account-updater.js";
import { ArrowUp as o } from "./arrow-up.js";
import { ArrowSmall as m } from "./arrow-small.js";
import { Close as i } from "./close.js";
import { FastCheckout as p } from "./fast-checkout.js";
import { Queue as t } from "./queue.js";
import { ShoppingCart as e } from "./shopping-cart.js";
import { User as f } from "./user.js";
import { UserBusiness as s } from "./user-business.js";
import { UserAdmin as a } from "./user-admin.js";
import { UserAdminPin as c } from "./user-admin-pin.js";
import { UserDeveloper as l } from "./user-developer.js";
import { UserPencil as U } from "./user-pencil.js";
import { UserStar as n } from "./user-star.js";
import { Users2 as C } from "./users-2.js";
import { Users3 as k } from "./users-3.js";
import { Recycle as d } from "./recycle.js";
import { Users4 as h } from "./users-4.js";
import { Users5 as u } from "./users-5.js";
import { Users9 as S } from "./users-9.js";
import { ZoomIn as A } from "./zoom-in.js";
import { ZoomOut as g } from "./zoom-out.js";
import { UserBackground as w } from "./user-background.js";
import { UserHeart as F } from "./user-heart.js";
import { UserMinus as P } from "./user-minus.js";
import { UserPlus as B } from "./user-plus.js";
import { UserClose as b } from "./user-close.js";
import { UserLock as D } from "./user-lock.js";
import { UsersBag as I } from "./users-bag.js";
import { UsersBaggage as y } from "./users-baggage.js";
import { UserGraph as L } from "./user-graph.js";
import { Search2 as x } from "./search2.js";
import { ShopperBag as R } from "./shopper-bag.js";
import { ShopperRisk as Z } from "./shopper-risk.js";
import { ShopperBagAction as v } from "./shopper-bag-action.js";
import { Support as G } from "./support.js";
import { Filter as H } from "./filter.js";
import { Play as M } from "./play.js";
import { PlayFilled as O } from "./play-filled.js";
import { StarCircle as Q } from "./star-circle.js";
import { StarCircleFilled as T } from "./star-circle-filled.js";
import { CheckboxDouble as W } from "./checkbox-double.js";
import { CheckmarkCircle as _ } from "./checkmark-circle.js";
import { CheckmarkCircleFilled as j } from "./checkmark-circle-filled.js";
import { TwoArrowsDown as q } from "./two-arrows-down.js";
import { _2ArrowsDown as z } from "./2-arrows-down.js";
import { ArrowUp1 as E } from "./arrow-up-1.js";
import { Bookmark as J } from "./bookmark.js";
import { Checkmark as K } from "./checkmark.js";
import { CrossCircle as N } from "./cross-circle.js";
import { FaceId as V } from "./face-id.js";
import { FaceIdApple as X } from "./face-id-apple.js";
import { Feedback as Y } from "./feedback.js";
import { Feedback2 as $ } from "./feedback2.js";
import { LoadingLine as rr } from "./loading-line.js";
import { PlusCircle as or } from "./plus-circle.js";
import { PlusIcon as mr } from "./plus-icon.js";
import { Search as ir } from "./search.js";
import { SearchCross as pr } from "./search-cross.js";
import { UserPassword as tr } from "./user-password.js";
import { UserWarning as er } from "./user-warning.js";
const Co = {
  AccountUpdater: r,
  ArrowUp: o,
  ArrowSmall: m,
  Close: i,
  FastCheckout: p,
  Queue: t,
  ShoppingCart: e,
  User: f,
  UserBusiness: s,
  UserAdmin: a,
  UserAdminPin: c,
  UserDeveloper: l,
  UserPencil: U,
  UserStar: n,
  Users2: C,
  Users3: k,
  Recycle: d,
  Users4: h,
  Users5: u,
  Users9: S,
  ZoomIn: A,
  ZoomOut: g,
  UserBackground: w,
  UserHeart: F,
  UserMinus: P,
  UserPlus: B,
  UserClose: b,
  UserLock: D,
  UsersBag: I,
  UsersBaggage: y,
  UserGraph: L,
  Search2: x,
  ShopperBag: R,
  ShopperRisk: Z,
  ShopperBagAction: v,
  Support: G,
  Filter: H,
  Play: M,
  PlayFilled: O,
  StarCircle: Q,
  StarCircleFilled: T,
  CheckboxDouble: W,
  CheckmarkCircle: _,
  CheckmarkCircleFilled: j,
  TwoArrowsDown: q,
  _2ArrowsDown: z,
  ArrowUp1: E,
  Bookmark: J,
  Checkmark: K,
  CrossCircle: N,
  FaceId: V,
  FaceIdApple: X,
  Feedback: Y,
  Feedback2: $,
  LoadingLine: rr,
  PlusCircle: or,
  PlusIcon: mr,
  Search: ir,
  SearchCross: pr,
  UserPassword: tr,
  UserWarning: er
};
export {
  Co as UiAndPeople
};
